import type { Capabilities, Permission, User } from "@/types";

export type PlanFeature = Exclude<
  keyof Capabilities,
  "projectLimit" | "teamMemberLimit" | "diaryPhotoLimit" | "galleryPhotoLimit"
>;

const PREFIX_FEATURES: Array<{ prefix: string; feature: PlanFeature }> = [
  { prefix: "project.clientBudgets.", feature: "clientBudgets" },
  { prefix: "project.purchaseRequests.", feature: "purchasing" },
  { prefix: "project.quotations.", feature: "purchasing" },
  { prefix: "project.purchaseOrders.", feature: "purchasing" },
  { prefix: "finance.payables.", feature: "finance" },
  { prefix: "finance.receivables.", feature: "finance" },
  { prefix: "finance.cashFlow.", feature: "finance" },
  { prefix: "finance.fiscal.", feature: "fiscal" },
];

const EXACT_FEATURES: Partial<Record<Permission, PlanFeature>> = {
  "nav.dashboard": "companyDashboard",
  "nav.finance": "finance",
  "settings.financeLookups": "finance",
  "settings.fiscal": "fiscal",
  "templates.manage": "permissionTemplates",
  "project.projectReport.manageModels": "reportModels",
  "settings.serviceFrontModels": "serviceFrontModels",
};

export function planFeatureForPermission(permission: Permission): PlanFeature | null {
  const exact = EXACT_FEATURES[permission];
  if (exact) return exact;
  for (const { prefix, feature } of PREFIX_FEATURES) {
    if (permission.startsWith(prefix)) return feature;
  }
  return null;
}

/** Missing capabilities do not extra-block (tests / loading). Explicit false blocks. */
export function planAllowsPermission(
  user: User | null | undefined,
  permission: Permission,
): boolean {
  const feature = planFeatureForPermission(permission);
  if (!feature) return true;
  const caps = user?.capabilities;
  if (!caps) return true;
  return caps[feature] === true;
}
